import { MessageCircle, Phone } from "lucide-react";
import { useSiteSettings } from "@/lib/settings";

const StickyButtons = () => {
  const contacts = useSiteSettings();
  return (
  <>
    <a
      href={contacts.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label="Chatta su WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#4A6B53] text-ivory shadow-xl shadow-sage/40 transition-all duration-300 hover:scale-110 hover:bg-sage-dark"
    >
      <MessageCircle size={24} strokeWidth={1.8} />
    </a>
    <a
      href={contacts.phoneHref}
      data-testid="call-now-button"
      className="fixed bottom-5 left-5 z-50 flex items-center gap-2 rounded-full bg-terracotta px-5 py-3.5 text-sm font-semibold text-ivory shadow-xl shadow-terracotta/35 transition-all duration-300 hover:scale-105 hover:bg-wood"
    >
      <Phone size={17} />
      <span className="hidden sm:inline">Chiama Ora</span>
    </a>
  </>
);
};

export default StickyButtons;
